import { ref, watch } from "vue"

export function useCotizadorState() {

  const sinVuelo = ref(false)

  const soloDirectos = ref(false)

  const destino = ref("PUJ")

  const origen = ref("MDE")

  const telefono = ref("")

  const visa = ref("sin_visa")

  const modalVueloVisible = ref(false)

  const recobro = ref(false)
  const valorRecobro = ref(0)


  watch(recobro, (nuevoValor) => {
    if (!nuevoValor) {
      valorRecobro.value = 0
    }
  })
  return {

    sinVuelo,

    soloDirectos,

    destino,

    origen,

    telefono,

    visa,

    modalVueloVisible,
    recobro,
    valorRecobro

  }

}